if (!window.initProductInfoTooltips) {
  window.initProductInfoTooltips = function initProductInfoTooltips(context = document) {
    context.querySelectorAll('.variant-tooltip-wrap').forEach((wrap) => {
      const trigger = wrap.querySelector('[data-product-info-tooltip-trigger]');
      const tooltip = wrap.querySelector('.variant-tooltip');
      const getTooltipTopBoundary = () => {
        const pad = 16;
        const stickyHeader = document.querySelector('.sticky-header-wrapper');
        const stickyHeaderRect = stickyHeader?.getBoundingClientRect();

        if (stickyHeaderRect && stickyHeaderRect.top < window.innerHeight && stickyHeaderRect.bottom > pad) {
          return stickyHeaderRect.bottom + 8;
        }

        return pad;
      };
      const resetTooltipPosition = () => {
        wrap.classList.remove('--tooltip-below');
        if (tooltip) tooltip.style.setProperty('--variant-tooltip-shift', '0px');
      };
      const clampTooltipPosition = (onPositioned) => {
        if (!tooltip) return;
        resetTooltipPosition();
        requestAnimationFrame(() => {
          const pad = 16;
          const topBoundary = getTooltipTopBoundary();
          let rect = tooltip.getBoundingClientRect();

          if (rect.top < topBoundary) {
            wrap.classList.add('--tooltip-below');
            rect = tooltip.getBoundingClientRect();
          }

          const maxRight = window.innerWidth - pad;
          let shift = 0;

          if (rect.left < pad) {
            shift = pad - rect.left;
          } else if (rect.right > maxRight) {
            shift = maxRight - rect.right;
          }

          tooltip.style.setProperty('--variant-tooltip-shift', `${Math.round(shift)}px`);
          if (typeof onPositioned === 'function') onPositioned();
        });
      };

      if (!wrap.dataset.tooltipHoverBound) {
        let showTimeout = null;
        let hideTimeout = null;
        let resetTimeout = null;
        let resetTransitionHandler = null;

        const cancelTooltipPositionReset = () => {
          clearTimeout(resetTimeout);
          if (tooltip && resetTransitionHandler) {
            tooltip.removeEventListener('transitionend', resetTransitionHandler);
          }
          resetTransitionHandler = null;
        };

        const resetTooltipPositionAfterTransition = () => {
          if (!tooltip) {
            resetTooltipPosition();
            return;
          }

          cancelTooltipPositionReset();

          const finishReset = () => {
            cancelTooltipPositionReset();
            resetTooltipPosition();
          };

          resetTransitionHandler = (event) => {
            if (event.target === tooltip && event.propertyName === 'opacity') {
              finishReset();
            }
          };

          tooltip.addEventListener('transitionend', resetTransitionHandler);
          resetTimeout = setTimeout(finishReset, 280);
        };

        const show = () => {
          if (window.matchMedia('(max-width: 900px)').matches) return;
          clearTimeout(hideTimeout);
          cancelTooltipPositionReset();
          showTimeout = setTimeout(() => {
            if (!tooltip) {
              wrap.classList.add('--tooltip-active');
              return;
            }
            clampTooltipPosition(() => wrap.classList.add('--tooltip-active'));
          }, 240);
        };

        const hide = () => {
          clearTimeout(showTimeout);
          hideTimeout = setTimeout(() => {
            wrap.classList.remove('--tooltip-active');
            resetTooltipPositionAfterTransition();
          }, 80);
        };

        wrap.addEventListener('mouseenter', show);
        wrap.addEventListener('mouseleave', hide);
        if (trigger) {
          trigger.addEventListener('focus', show);
          trigger.addEventListener('blur', hide);
        }
        wrap.dataset.tooltipHoverBound = 'true';
      }

      if (trigger && !trigger.dataset.tooltipModalBound) {
        if (trigger.dataset.tooltipStopPropagation === 'true') {
          ['pointerdown', 'mousedown', 'touchstart'].forEach((eventName) => {
            trigger.addEventListener(eventName, (e) => e.stopPropagation(), { capture: true });
          });
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
          });
        }

        const openModal = (e) => {
          if (trigger.dataset.tooltipStopPropagation === 'true') {
            e.preventDefault();
            e.stopPropagation();
          }
          if (trigger.dataset.tooltipForceModal !== 'true' && !window.matchMedia('(max-width: 900px)').matches) return;
          e.preventDefault();
          e.stopPropagation();
          const modalId = wrap.dataset.modalTarget;
          const modal = modalId ? document.getElementById(modalId) : null;
          if (!modal) return;
          wrap.classList.add('--tooltip-active');
          trigger.setAttribute('aria-expanded', 'true');
          modal._activeTooltipWrap = wrap;
          modal._activeTooltipTrigger = trigger;
          modal.hidden = false;
          requestAnimationFrame(() => requestAnimationFrame(() => modal.classList.add('is-open')));
          document.body.classList.add('product-info-modal-open');
        };

        trigger.addEventListener('click', openModal);
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            openModal(e);
          }
        });
        trigger.dataset.tooltipModalBound = 'true';
      }
    });

    context.querySelectorAll('.product-info-modal').forEach((modal) => {
      if (modal.dataset.tooltipModalBound) return;

      const close = () => {
        if (modal.hidden) return;
        modal.classList.remove('is-open');
        if (modal._activeTooltipWrap) {
          modal._activeTooltipWrap.classList.remove('--tooltip-active');
          modal._activeTooltipWrap = null;
        }
        if (modal._activeTooltipTrigger) {
          modal._activeTooltipTrigger.setAttribute('aria-expanded', 'false');
          modal._activeTooltipTrigger = null;
        }
        const panel = modal.querySelector('.product-info-modal_panel');
        panel.addEventListener('transitionend', () => {
          modal.hidden = true;
          document.body.classList.remove('product-info-modal-open');
        }, { once: true });
      };

      const consume = (event) => {
        event.preventDefault();
        event.stopPropagation();
      };
      const consumeAndClose = (event) => {
        consume(event);
        close();
      };
      const panel = modal.querySelector('.product-info-modal_panel');
      const backdrop = modal.querySelector('.product-info-modal_backdrop');
      const closeButton = modal.querySelector('.product-info-modal_close');

      ['pointerdown', 'pointerup', 'mousedown', 'touchstart', 'touchend', 'click'].forEach((eventName) => {
        const shouldClose = eventName === 'pointerup' || eventName === 'touchend' || eventName === 'click';
        panel?.addEventListener(eventName, consume);
        backdrop?.addEventListener(eventName, shouldClose ? consumeAndClose : consume);
        closeButton?.addEventListener(eventName, shouldClose ? consumeAndClose : consume);
      });
      modal.dataset.tooltipModalBound = 'true';
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.initProductInfoTooltips(document);
  });
}
